<template>
  <div class="elevation-3 ma-3 pa-1">
    <v-row>
      <v-col cols="3" sm="4" class="pt-5 pb-0 mt-n6">
        <v-autocomplete :items="userList"
          v-model="selectedUser"
          class="input-text-size" label="Select user To Assign"
          item-text="fullname" item-value="username"
        />
      </v-col>
      <v-col cols="3" sm="4">
        <div class="d-flex mb-1 mt-1">
          <v-btn class="input-text-size mr-2"
           text color="blue darken-1"
           @click="callAssignUserSelectedRecords"
          >
            Assign user Selected Record
          </v-btn>
          <v-btn class="input-text-size"
           text color="blue darken-1"
           @click="validatePaidSelectedRecords"
          >
            Validate Paid
          </v-btn>
        </div>
      </v-col>

    </v-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'OverpaymentFooter',
  props: {
  },
  data() {
    return {
      selectedUser: '',
      userList: [],
    };
  },
  created() {
    this.loadUsersList();
  },
  methods: {
    ...mapActions('UserAdministration', [
      'loadUsers',
    ]),
    callAssignUserSelectedRecords() {
      const selected = this.userList.find((ft) => ft.username === this.selectedUser);
      const fullname = selected && selected.fullname ? selected.fullname : this.selectedUser;
      this.$emit('assignUserSelectedRecords', this.selectedUser, fullname);
    },
    validatePaidSelectedRecords() {
      this.$emit('validatePaidRecords');
    },
    async loadUsersList() {
      const users = await this.loadUsers();
      const taxUsers = (users || []).filter((item) => {
        const { roles } = item;
        return !item.isSystemUser && (roles.includes('TAXADMINISTRATION') || roles.includes('TAXUSER'));
      });
      taxUsers.sort((a, b) => (a.fullname || '').localeCompare(b.fullname || ''));
      this.userList = [{ fullname: '', username: '' }, ...taxUsers];
    },
  },
};
</script>
